import { Box } from '@mui/system';
import React from 'react';
import TCDAccordion from 'routes/HumanResourcesModule/components/TCDAccordion';
import { getExercicePeriodFormatted } from '../../helpers/dataHelpers';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

export type DataPointT = {
    current: number;
    deltaFormatted: string;
    previous?: number;
};

type Props = {
    title: string;
    exercice: number;
    data: DataPointT[];
    children: React.ReactElement;
};

const getTrendingIcon = ({ current, previous }: DataPointT) => {
    if (previous === undefined) return TrendingFlatIcon;
    if (current > previous) return TrendingUpIcon;
    if (current < previous) return TrendingDownIcon;
    return TrendingFlatIcon;
};

const PayStateBanner = ({
    title,
    data,
    exercice,
    children,
}: Props): React.ReactElement => {
    const period = getExercicePeriodFormatted(exercice);

    const indicators = (
        <Box
            sx={{
                flexGrow: '1',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                color: 'white',
            }}
        >
            {data.map((d, i) => {
                const Icon = getTrendingIcon(d);
                return (
                    <Box
                        key={`indi-${i}`}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: '700',
                            marginLeft: '24px',
                        }}
                    >
                        {d.deltaFormatted}{' '}
                        <Icon
                            sx={{
                                borderRadius: '100%',
                                backgroundColor: 'rgba(255,255,255,0.15)',
                                width: '1em',
                                height: '1em',
                                padding: '4px',
                                marginLeft: '8px',
                            }}
                        />
                    </Box>
                );
            })}
        </Box>
    );
    return (
        <TCDAccordion title={title} extraElement={indicators} chip={period}>
            {children}
        </TCDAccordion>
    );
};

export default PayStateBanner;
